import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';

import ICreateThreadMessageInterventionResponse from 'services/httpClient/responses/intervention/ICreateThreadMessageInterventionResponse';

import { IInterventionData } from '../../initialState';

interface ICreateThreadMessageSuccessActionPayload {
  message: ICreateThreadMessageInterventionResponse;
  threadMessageId: number;
}

function createThreadMessageSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<ICreateThreadMessageSuccessActionPayload>,
) {
  draft.createThreadMessage.config.isLoading = false;
  draft.getAllThreads.list = draft.getAllThreads.list.map(thread => {
    if (thread.threadMessageId === action.payload.threadMessageId) {
      const messageFormatted = {
        text: action.payload.message.text,
        companyname: action.payload.message.companyname,
        wroteBy: action.payload.message.wrote_by,
        createdAt: formatters.date(action.payload.message.created_at, {
          formatType: 'DD/MM',
        }),
        name: action.payload.message.name,
        id: action.payload.message.id,
        open: action.payload.message.open,
        subject: thread.subject,
      };

      return {
        ...thread,
        messages: thread.messages.concat(messageFormatted),
      };
    }

    return thread;
  });
}

export default createThreadMessageSuccess;
